import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * A row of link chips (mandals, districts, subcategories).
 * Scrolls sideways on phones and wraps on wider screens; the active chip is scrolled into view.
 * items: [{ key, label, to, active }]
 */
export function FilterChips({ items, label }) {
  const { isHindi } = useLanguage();
  const activeRef = useRef(null);
  const activeKey = items.find((i) => i.active)?.key;

  // Centre the active chip within the row only (scrollIntoView would also scroll the page)
  useEffect(() => {
    const chip = activeRef.current;
    const row = chip?.parentElement;
    if (!chip || !row || row.scrollWidth <= row.clientWidth) return;
    row.scrollLeft = chip.offsetLeft - row.offsetLeft - (row.clientWidth - chip.offsetWidth) / 2;
  }, [activeKey]);

  return (
    <nav aria-label={label} className="-mx-4 px-4 sm:mx-0 sm:px-0">
      <div className="flex gap-2 overflow-x-auto pb-1 sm:flex-wrap sm:overflow-visible">
        {items.map((item) => (
          <Link
            key={item.key}
            ref={item.active ? activeRef : undefined}
            to={item.to}
            aria-current={item.active ? 'page' : undefined}
            className={`shrink-0 inline-flex items-center min-h-[40px] px-4 border font-ui text-[13px] transition-colors ${
              item.active
                ? 'bg-[var(--ink)] border-[var(--ink)] text-white font-semibold'
                : 'bg-white border-[var(--rule)] text-[var(--ink)] hover:border-[var(--ink)]'
            } ${isHindi ? 'font-hindi' : ''}`}
          >
            {item.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}
